export function sortFn(a, b, field, direction = "asc") {
    let valA, valB;
    switch (field) {
      case "name":
        // Para nomes, objetos têm a chave Key, pastas são strings
        valA = typeof a === "string" ? a : a.Key;
        valB = typeof b === "string" ? b : b.Key;
        break;
      case "type":
        // Tipo pelo sufixo da extensão
        valA = (typeof a === "string" ? a : a.Key).split('.').pop().toLowerCase();
        valB = (typeof b === "string" ? b : b.Key).split('.').pop().toLowerCase();
        break;
      case "date":
        // Data de modificação; pastas não têm data
        valA = a.LastModified ? new Date(a.LastModified) : new Date(0);
        valB = b.LastModified ? new Date(b.LastModified) : new Date(0);
        break;
      case "size":
        // Tamanho em bytes; pastas 0
        valA = a.Size || 0;
        valB = b.Size || 0;
        break;
      default:
        return 0;
    }
    if (valA < valB) return direction === "asc" ? -1 : 1;
    if (valA > valB) return direction === "asc" ? 1 : -1;
    return 0;
  }
  